<dds-footer class="container">
    <div content [innerHTML]="safeFooterDataHtml"></div>
    <div content class="footer-links">
        <a target="_blank" href="https://www2.deloitte.com/us/en/legal/terms-of-use.html" class="terms-link">Terms of Use</a>
        | 
        <a target="_blank" href="https://cookienotice.deloitte.com" class="cookies-link">Cookies</a>
        | 
        <a class="optanon-toggle-display cookie-settings-link">Cookie Settings</a>
    </div>
</dds-footer>